import { Button, Form, Radio } from 'antd'
import React, { useState } from 'react'
import { connect, useSelector } from 'react-redux'
import TextArea from 'antd/es/input/TextArea'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import { useParams } from 'react-router'
import {
    getLlmVersionDescription,
    getLlmVersionName,
    LLM_VERSIONS,
    LLM_VERSIONS_VALUE_TO_NAME,
} from '../../../../../constants/llm-versions'
import { isTextAssignment } from '../../../../../utils/assignment.helper'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import { validateNoEmptySpaces } from '../../../../../utils/antd.helper'
import { useAutoFocusFirstInput } from '../../../../../../hooks/useAutoFocusFirstInput'

const DefineDescriptionStep = ({ moveToNextStep, generateAndProjectCriteria }) => {
    const { token, layerId } = useParams()
    const language = useSelector(assignmentSelectors.language)

    const [form] = Form.useForm()
    useAutoFocusFirstInput()
    const [isWaitingForGenerateCriteria, setIsWaitingForGenerateCriteria] = useState(false)

    const handleSubmitClick = async () => {
        setIsWaitingForGenerateCriteria(true)
        const criteria = await generateAndProjectCriteria(
            token,
            layerId,
            form.getFieldValue('description').trim(),
            form.getFieldValue('llmVersion'),
        )
        setIsWaitingForGenerateCriteria(false)
        if (criteria) moveToNextStep()
    }

    const llmVersionOptions = Object.keys(LLM_VERSIONS_VALUE_TO_NAME).map(key => ({
        label: getLlmVersionName(key),
        value: key,
        title: getLlmVersionDescription(key),
        disabled: LLM_VERSIONS.FAST.value === key && isTextAssignment(language),
    }))

    return (
        <Form
            name='define-description'
            autoComplete='off'
            form={form}
            onFinish={handleSubmitClick}
            requiredMark={false}
            layout='vertical'
        >
            <Form.Item
                name='description'
                label='Description'
                rules={[
                    { required: true, message: 'Please, enter the description' },
                    { validator: validateNoEmptySpaces },
                ]}
            >
                <TextArea
                    disabled={isWaitingForGenerateCriteria}
                    rows={12}
                    placeholder='Enter high level description to create pattern from'
                />
            </Form.Item>
            <Form.Item label='LLM version' name='llmVersion' initialValue={LLM_VERSIONS.DEEP.value}>
                <Radio.Group options={llmVersionOptions} optionType='button' />
            </Form.Item>
            <Form.Item className='mb-0'>
                <Button type='primary' htmlType='submit' block loading={isWaitingForGenerateCriteria}>
                    Create
                </Button>
            </Form.Item>
        </Form>
    )
}

const mapDispatch = dispatch => {
    return {
        generateAndProjectCriteria(token, layerId, description, llmVersion) {
            return dispatch(actions.generateAndProjectCriteria(token, layerId, description, llmVersion))
        },
    }
}

export default connect(null, mapDispatch)(DefineDescriptionStep)
